var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEnterpriseinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.167 30a.833.833 0 00.833-.833.417.417 0 00-.417-.417h-7.5a.417.417 0 110-.833h7.5A.417.417 0 0030 27.5v-.417a.417.417 0 00-.417-.416h-7.5a.416.416 0 110-.834h7.5a.417.417 0 00.417-.416V25a.417.417 0 00-.208-.36.416.416 0 01-.209-.363V10.833A.834.834 0 0028.75 10h-5.417a.417.417 0 00-.416.417v13.75a.416.416 0 01-.417.416h-.417a.417.417 0 01-.416-.416v-13.75A.417.417 0 0021.25 10h-10A1.25 1.25 0 0010 11.25v17.5A1.25 1.25 0 0011.25 30h17.917zM26.25 12.083a1.667 1.667 0 110 3.335 1.667 1.667 0 010-3.335zm-1.667 10a1.667 1.667 0 013.334 0v2.084a.416.416 0 01-.417.416H25a.417.417 0 01-.417-.416v-2.084zm-10 3.75a.417.417 0 01-.416.417h-2.084a.417.417 0 01-.416-.417v-2.708a1.458 1.458 0 112.916 0v2.708zm0-8.333a.417.417 0 01-.416.417h-2.084a.416.416 0 01-.416-.417v-2.708a1.458 1.458 0 112.916 0V17.5zM20 25.833a.417.417 0 01-.417.417H17.5a.417.417 0 01-.417-.417v-2.708a1.458 1.458 0 012.917 0v2.708zm0-8.333a.417.417 0 01-.417.417H17.5a.416.416 0 01-.417-.417v-2.708a1.458 1.458 0 012.917 0V17.5z",
    fill: "#0F0449"
  })));
}

export default SvgEnterpriseinline;